import React from 'react';
import { motion } from 'framer-motion';
import { Instagram } from 'lucide-react';
import { studioInfo } from '../mock';

const FloatingSocialButtons = () => {
  const phoneNumber = studioInfo.phone.replace(/[^\d]/g, '');
  const message = encodeURIComponent(
    'Salve, vorrei richiedere informazioni per un preventivo.'
  );
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
  const instagramUrl = 'https://www.instagram.com/geom.gabrielepastore?igsh=cWcxMDI3aGtnN3l0&utm_source=qr';

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.15, delayChildren: 1.2 }
    }
  };

  const item = {
    hidden: { scale: 0, opacity: 0 },
    show: { scale: 1, opacity: 1, transition: { type: 'spring', stiffness: 200 } }
  };

  return (
    <motion.div
      variants={container}
      initial="hidden"
      animate="show"
      className="fixed bottom-6 right-6 z-[90] flex items-center gap-3"
    >
      {/* Instagram Button */}
      <motion.a
        variants={item}
        href={instagramUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Seguici su Instagram"
        data-testid="floating-instagram-button"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        className="group relative"
      >
        <span className="relative flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 bg-gradient-to-tr from-[#F58529] via-[#DD2A7B] to-[#8134AF] rounded-full shadow-2xl hover:shadow-[0_0_30px_rgba(221,42,123,0.6)] transition-all duration-300 border-2 border-white/20">
          <Instagram className="w-6 h-6 sm:w-7 sm:h-7 text-white" strokeWidth={2} />
        </span>

        {/* Tooltip desktop */}
        <span className="hidden md:block absolute bottom-full mb-3 left-1/2 -translate-x-1/2 whitespace-nowrap bg-[#0A1628] text-white text-sm font-medium px-4 py-2 rounded-full shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none border border-white/10">
          Seguici su Instagram
          <span className="absolute top-full left-1/2 -translate-x-1/2 border-8 border-transparent border-t-[#0A1628]" />
        </span>
      </motion.a>

      {/* WhatsApp Button */}
      <motion.a
        variants={item}
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contattaci su WhatsApp"
        data-testid="whatsapp-button"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        className="group relative"
      >
        {/* Pulse animation */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-40" />

        <span className="relative flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 bg-gradient-to-br from-[#25D366] to-[#128C7E] rounded-full shadow-2xl hover:shadow-[0_0_30px_rgba(37,211,102,0.6)] transition-all duration-300 border-2 border-white/20">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="white"
            className="w-7 h-7 sm:w-8 sm:h-8"
          >
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
          </svg>
        </span>

        {/* Tooltip desktop */}
        <span className="hidden md:block absolute bottom-full mb-3 left-1/2 -translate-x-1/2 whitespace-nowrap bg-[#0A1628] text-white text-sm font-medium px-4 py-2 rounded-full shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none border border-white/10">
          Scrivici su WhatsApp
          <span className="absolute top-full left-1/2 -translate-x-1/2 border-8 border-transparent border-t-[#0A1628]" />
        </span>
      </motion.a>
    </motion.div>
  );
};

export default FloatingSocialButtons;
